/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TreatmentColors/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TreatmentColor from './TreatmentColor/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TreatmentColors({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/TreatmentColors"
  
}) {
let eventAppointmentTxColorsValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'appointment.tx.colors',
format: fromHelpers.getColors,
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
  return (<React.Fragment
>
<div
  data-testid="TreatmentColors.List"
  data-view-path={viewPath}
 style={{'--g-1-FEhld': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(eventAppointmentTxColorsValueData) && eventAppointmentTxColorsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="color"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/TreatmentColor(${item?.id ?? item?._id ?? index})`}
      >
<TreatmentColor
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/TreatmentColor(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }